import { ApiField, ApiSection } from "@/types/custom-field.types.ts";
import { ReactNode } from "react";

export interface CustomFieldViewSection {
  section: ApiSection;
  items: { field: ApiField; node: ReactNode }[];
}

export const getCustomFieldViewSections = (
  sections: (ApiSection & { fields: ApiField[] })[],
  renderField: (field: ApiField) => ReactNode | undefined
): CustomFieldViewSection[] =>
  sections
    .map((section) => ({
      section,
      items: section.fields
        .map((field) => ({ field, node: renderField(field) }))
        .filter(({ node }) => node),
    }))
    .filter(({ items }) => items.length);
